import React, { Component } from "react";
import { Link } from "react-router-dom";
import InfoMsgBox from "../UIComponents/MessageBox/InfoMsgBox";
import axios from "axios";
import LZString from 'lz-string';
import { ApiGateWay } from "./../ApiGateWay/ApiGateWay";
import Cookie from "js-cookie";
import { Config } from "./../config/config";
import Example from "./Example";

class DataTables extends Component {
  constructor(props) {
    super(props);
    // alert(JSON.stringify(this.props.data));
    const config = JSON.parse(Config);
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user["userId"];
    this.state = {
      evacuationCount: [0, 0, 0, 0, 0],
      apiInterface: config["api"],

      storeDashboard: this.props.storeDashboard,
      storeid: props.storeid,

      alerts: [],
      alertno: [],
      incientTypeCount: [],
      incidentDiffTypes: [],
      loader: props.loader,
      proxyjson: props.data,
      tabid: "",
      modalOpenGrid: false,
      message: [],
      category: props.name,
      userID,
      year: props.year,
      someS: [],
      dataForSafetyRegister: false,
      month: props.month,

      loading: false,
    };
    //this.fetchApiData=this.fetchApiData.bind(this)
  }

  handleClose = () => {
    this.setState({
      modalOpenGrid: false,
      message: "",
    });
  };

  handlGridClick = (event) => {
    // alert(JSON.stringify(event.target.dataset.value));
    event.preventDefault();
    this.setState({
      dataForSafetyRegister: false,
    });
    if (this.props.title == "HandoversBSU") {
      let data = JSON.parse(event.target.dataset.value);
      let handoverData = [];

      ApiGateWay.Get(
        this.state.apiInterface +
          "/fetchBSUMonthlyScoreDetails?storeId=" +
          data.storeId +
          "&month=" +
          this.props.month +
          "&year=" +
          this.props.year
      )
        .then((response) => response.json())
        .then((response) => {
          response.monthlyHandoverPopUpGridModels.map((info) => {
            handoverData.push([
              info.sportName,
              info.checklistDate,
              info.checklistScore,
              info.handOverstatus,
              info.userName,
            ]);
          });

          data.popUpData = handoverData;

          this.setState({
            modalOpenGrid: !this.state.modalOpenGrid,
            message: JSON.stringify(data),
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: false,
            message: "Unable to retrieve the data. Please try again later",
          });
        });
    } else if (this.props.dataClick == "Noncoformities") {
      let data = JSON.parse(event.target.dataset.value);
      let nonConfirmityData = [];
      let status = "";
      let checklistName = "";
      let month = "";
      let type = data.stype;

      if (data.storeName == "January") {
        month = 1;
      } else if (data.storeName == "February") {
        month = 2;
      } else if (data.storeName == "March") {
        month = 3;
      } else if (data.storeName == "April") {
        month = 4;
      } else if (data.storeName == "May") {
        month = 5;
      } else if (data.storeName == "June") {
        month = 6;
      } else if (data.storeName == "July") {
        month = 7;
      } else if (data.storeName == "August") {
        month = 8;
      } else if (data.storeName == "September") {
        month = 9;
      } else if (data.storeName == "October") {
        month = 10;
      } else if (data.storeName == "November") {
        month = 11;
      } else if (data.storeName == "December") {
        month = 12;
      } else if (data.storeName == "Till Date") {
        month = this.props.month;
        type = "";
      } else {
        month = this.props.month;
      }
      if (data.columns === "Open") {
        status = 0;
      } else {
        status = 1;
      }
      if (data.head === "Daily Count") {
        checklistName = "Daily";
      } else if (data.head === "Weekly Count") {
        checklistName = "Weekly";
      } else if (data.head === "SOD Count") {
        checklistName = "Monthly SOD";
      } else if (data.head === "Flows Count") {
        checklistName = "Monthly Flows";
      } else if (data.head === "BSU Count") {
        checklistName = "Monthly BSU";
      } else if (data.head === "Additional Count") {
        checklistName = "Additional NC";
      } else {
        checklistName = "";
      }
      ApiGateWay.Get(
        this.state.apiInterface +
          "/fetchStorewiseNonConfirmityDetails?storeId=" +
          data.storeId +
          "&month=" +
          month +
          "&year=" +
          this.props.year +
          "&status=" +
          status +
          "&checklistName=" +
          checklistName +
          "&type=" +
          type
      )
        .then((response) => response.json())
        .then((response) => {
          response.nonConfirmityInfo.map((info) => {
            nonConfirmityData.push([
              info.description,

              info.ncDueDate,
              info.ncCreatedDate,
              info.ncCreatedBy,
              info.ncAssignedTo,
              info.ncSource,
              info.ncStatus,
              info.comments,
            ]);
          });

          data.popUpData = nonConfirmityData;

          this.setState({
            modalOpenGrid: !this.state.modalOpenGrid,
            message: JSON.stringify(data),
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            modalOpen: false,
            message: "Unable to retrieve the data. Please try again later",
          });
        });
    } else if (this.props.dataClick == "safetyRegister") {
      let cAndCdata = JSON.parse(event.target.dataset.value);

      let ComplianceData = [];
      if (cAndCdata.head === "Contracts") {
        ApiGateWay.Get(
          this.state.apiInterface +
            "/loadContractGlobalDashboardDetail?storeId=" +
            cAndCdata.storeId +
            "&month=" +
            this.props.month +
            "&year=" +
            this.props.year
        )
          .then((response) => response.json())
          .then((response) => {
            let contractsData = [];
            response.contractInfos.map((info, val) => {
              contractsData.push([
                val + 1,
                info.documentType,
                info.uploadedDate,
                info.expiryDate,
                info.uploadedBy,
                info.overAllStatus,
                info.documentPath,
              ]);
            });

            cAndCdata.popUpData = contractsData;

            this.setState({
              modalOpenGrid: !this.state.modalOpenGrid,
              message: JSON.stringify(cAndCdata),
              dataForSafetyRegister: true,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: false,
              message: "Unable to retrieve the data. Please try again later",
            });
          });
      } else if (cAndCdata.head === "Compliance") {
        ApiGateWay.Get(
          this.state.apiInterface +
            "/loadComplianceGlobalDashboardDetail?storeId=" +
            cAndCdata.storeId +
            "&month=" +
            this.props.month +
            "&year=" +
            this.props.year
        )
          .then((response) => response.json())
          .then((response) => {
            response.complianceInfos.forEach((info, val) => {
              ComplianceData.push([
                val + 1,
                info.documentType,
                info.uploadedDate,
                info.expiryDate,
                info.uploadedBy,
                info.overAllStatus,
                info.documentPath,
              ]);
            });

            cAndCdata.popUpData = ComplianceData;

            this.setState({
              modalOpenGrid: !this.state.modalOpenGrid,
              message: JSON.stringify(cAndCdata),
              dataForSafetyRegister: true,
            });
          })
          .catch(() => {
            this.setState({
              loading: false,
              modalOpen: false,
              message: "Unable to retrieve the data. Please try again later",
            });
          });
      }
    } else {
      this.setState({
        modalOpenGrid: !this.state.modalOpenGrid,
        message: event.target.dataset.value,
      });
    }
  };

  render() {
    const { modalOpenGrid, message } = this.state;
    return (
      <>
        {this.props.msgVision ? null : modalOpenGrid ? (
          <InfoMsgBox
            message={message}
            headers={this.state.proxyjson.popUpDataGridHeaders}
            onClose={this.handleClose}
            dataForSafetyRegister={this.state.dataForSafetyRegister}
            loading={this.props.loading}
            pageLoad={this.props.pageLoad}
          />
        ) : null}

        <div className="row">
          <div className="col-xs-12" style={{ width: "100%" }}>
            {/* /.box-header */}
            <h3 className="box-title">
              {" "}
              {this.state.storeDashboard
                ? this.state.proxyjson.type == "Evacuations"
                  ? " No of Evacuations done YTD - " +
                    this.props.data.evacuationCount.reduce(
                      (result, number) => result + number
                    )
                  : null
                : null}
            </h3>

            <table
              className={
                this.props.dataClick == "Noncoformities"
                  ? this.state.proxyjson.storeType == 1
                    ? "table lastRow table-bordered table-non table-striped mainGrid"
                    : "table table-bordered table-non table-striped mainGrid"
                  : `table table-bordered table-striped mainGrid ${this.props.className? this.props.className:''}`
              }
              id="DataGrid"
              style={{
                borderCollapse: "separate",
                overflowX: "auto",
                //display: "block",
                // whiteSpace: "nowrap",
              }}
            >
              <thead
                className=""
                style={{
                  background: "#3c8dbc",
                  color: "#fff",
                  textAlign: "center",
                }}
              >
                <tr>
                  {this.props.dataClick == "Noncoformities" ? null : (
                    <th>S.NO</th>
                  )}
                  {this.state.proxyjson.thead &&
                  this.props.dataClick != "Noncoformities"
                    ? this.state.proxyjson.thead.map((val, index) => (
                        <th key={val + index} style={{ textAlign: "center", width:index==1&& this.state.proxyjson.type === "External Users" && 100 }}>
                          {val}{" "}
                        </th>
                      ))
                    : null}
                </tr>
                {this.props.dataClick == "Noncoformities" ? (
                  <tr>
                    <th rowSpan="2" style={{ paddingBottom: 46 }}>
                      S.NO
                    </th>
                    {this.props.name == "StorewiseNonconformities" ? (
                      <th style={{ textAlign: "center" }}>Months</th>
                    ) : (
                      <th style={{ textAlign: "center" }}>Stores</th>
                    )}
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      Daily Count
                    </th>
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      Weekly Count
                    </th>
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      SOD Count
                    </th>
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      Flows Count
                    </th>
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      BSU Count
                    </th>
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      Additional Count
                    </th>
                    <th colSpan="2" style={{ textAlign: "center" }}>
                      Total
                    </th>
                  </tr>
                ) : (
                  ""
                )}
                {this.props.dataClick == "Noncoformities" ? (
                  <tr>
                    {this.state.proxyjson.columns
                      ? this.state.proxyjson.columns.map((val, index) => (
                          <th key={val + index} style={{ textAlign: "center" }}>
                            {val}{" "}
                          </th>
                        ))
                      : null}
                  </tr>
                ) : (
                  ""
                )}
              </thead>
              <tbody>
                {this.state.proxyjson.tbody
                  ? this.state.proxyjson.tbody.map((data2, ind) => {
                      return (
                        <tr key={data2 + ind}>
                          {this.state.proxyjson.type == "Training" ? (
                            ind + 1 == 1 ||
                            ind + 1 == this.state.proxyjson.tbody.length ? (
                              <td
                                style={{
                                  textAlign: "center",
                                  backgroundColor: "#f4f4f4",
                                }}
                              ></td>
                            ) : (
                              <td
                                style={{
                                  textAlign: "center",
                                  backgroundColor: "#f4f4f4",
                                }}
                              >
                                {ind}
                              </td>
                            )
                          ) : (
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#f4f4f4",
                              }}
                            >
                              {ind + 1}
                            </td>
                          )}
                          {this.state.proxyjson.stores == "" ? null : (
                            <td style={{ textAlign: "center", background: "" }}>
                              {this.props.type == "retail" ? (
                                !this.state.storeDashboard ? (
                                  
                                  <Link to="/storeDashboardRetail" state={{ 
                                           tabIndex: this.props.tabIndex,
                                        storeName:
                                          this.state.proxyjson.stores[ind],
                                        storeId:
                                          this.state.proxyjson.storeId[ind],
                                        currentCity: this.props.currentCity,
                                        month: this.props.month,
                                        year: this.props.year,
                                   }} >
                                    {this.state.proxyjson.stores[ind]}
                                  </Link>
                                ) : (
                                  this.state.proxyjson.stores[ind]
                                )
                              ) : !this.state.storeDashboard ? (
                                
                                <Link to="/storeDashboardWareHouse" state={{ 
                                        tabIndex: this.props.tabIndex,
                                        warehouseName:
                                        this.state.proxyjson.stores[ind],
                                        warehouseid:
                                          this.state.proxyjson.storeId[ind],
                                        currentCity: this.props.currentCity,
                                        month: this.props.month,
                                        year: this.props.year,
                          }} >
                                  {this.state.proxyjson.stores[ind]}
                                </Link>
                              ) : (
                                this.state.proxyjson.stores[ind]
                              )}
                            </td>
                          )}
                          {data2.map((data3, index) => (
                            /* alert(
                                JSON.stringify(this.state.proxyjson.storeType)
                              ), */
                            <td
                              style={
                                data3
                                  ? data3.length >= 4 && !data3.includes("%")
                                    ? { textAlign: "center" }
                                    : this.props.align === "center"
                                    ? { textAlign: "center" }
                                    : { textAlign: "center" }
                                  : null
                              }
                              key={data3 + index}
                              className={
                                this.state.proxyjson.colorCodes[ind][index] ==
                                12
                                  ? "orangeColorString"
                                  : (this.props.dataClick == "safetyRegister" &&
                                      data3 > "0%" &&
                                      this.state.proxyjson.thead[index + 1] ==
                                        "Contracts") ||
                                    (this.props.dataClick == "safetyRegister" &&
                                      data3 > "0%" &&
                                      this.state.proxyjson.thead[index + 1] ==
                                        "Compliance")
                                  ? "greenColorNumber clickable"
                                  : this.state.proxyjson.colorCodes[ind][
                                      index
                                    ] != 0
                                  ? this.state.proxyjson.colorCodes[ind][
                                      index
                                    ] == 1
                                    ? typeof data3 == "string" ||
                                      data3 == "" ||
                                      data3 == null
                                      ? "greenColorString"
                                      : "greenColorNumber" ||
                                        (this.props.dataClick === "incidents" &&
                                          this.state.proxyjson.tbody[
                                            index + 0
                                          ][0] ===
                                            this.state.proxyjson.tbody[
                                              index + 0
                                            ][3] &&
                                          this.state.proxyjson.tbody[
                                            index + 0
                                          ][0] > 0)
                                      ? "greenColorNumber"
                                      : this.props.dataClick === "incidents" &&
                                        this.state.proxyjson.tbody[
                                          index + 0
                                        ][0] ===
                                          this.state.proxyjson.tbody[
                                            index + 0
                                          ][3] &&
                                        this.state.proxyjson.tbody[
                                          index + 0
                                        ][0] === 0
                                      ? ""
                                      : "redColorNumber"
                                    : typeof data3 == "string" ||
                                      data3 == "" ||
                                      data3 == null
                                    ? "redColorString"
                                    : "redColorNumber"
                                  : typeof data3 == "string" ||
                                    data3 == "" ||
                                    data3 == null
                                  ? null ||
                                    (this.props.dataClick == "Noncoformities" &&
                                      data3 > 0)
                                    ? "sa"
                                    : null
                                  : "clickable"
                              }
                              onClick={
                                this.state.proxyjson.popUpDataGrid == "none" ||
                                typeof data3 == "string" ||
                                data3 == "" ||
                                data3 == null
                                  ? this.props.dataClick == "safetyRegister" &&
                                    data3.split("%")[0] > 0
                                    ? this.handlGridClick
                                    : null ||
                                      (this.props.dataClick ==
                                        "Noncoformities" &&
                                        data3 > 0)
                                    ? this.handlGridClick
                                    : null
                                  : this.handlGridClick
                              }
                              data-value={
                                this.state.proxyjson.popUpDataGrid
                                  ? this.props.title == "HandoversBSU"
                                    ? JSON.stringify({
                                        popUpData:
                                          this.state.proxyjson.popUpDataGrid[
                                            ind
                                          ][index],
                                        storeName:
                                          this.state.proxyjson.stores[ind],
                                        storeId:
                                          this.state.proxyjson.storeId[ind],
                                        type: this.state.proxyjson.type,
                                        head: this.state.proxyjson.thead[
                                          index + 1
                                        ],
                                      })
                                    : this.props.dataClick == "safetyRegister"
                                    ? JSON.stringify({
                                        popUpData:
                                          this.state.proxyjson.popUpDataGrid[
                                            ind
                                          ][index],
                                        storeName:
                                          this.state.proxyjson.stores[ind],
                                        storeId: this.state.proxyjson.storeId
                                          ? this.state.proxyjson.storeId[ind]
                                          : this.props.storeid,
                                        type: this.state.proxyjson.type,
                                        head: this.state.proxyjson.thead[
                                          index + 1
                                        ],
                                      })
                                    : this.props.dataClick == "Noncoformities"
                                    ? JSON.stringify({
                                        popUpData:
                                          this.state.proxyjson.popUpDataGrid[
                                            ind
                                          ][index],
                                        storeName:
                                          this.state.proxyjson.stores[ind],
                                        storeId: this.state.proxyjson.storeId
                                          ? this.state.proxyjson.storeId[ind]
                                          : this.props.storeid,
                                        type: this.state.proxyjson.type,
                                        head: this.state.proxyjson.head[
                                          index + 1
                                        ],
                                        columns:
                                          this.state.proxyjson.columns[
                                            index + 1
                                          ],
                                        stype: this.state.proxyjson.storeType
                                          ? 1
                                          : "",
                                      })
                                    : this.props.name !== "IncidentsDateGrid" &&
                                      JSON.stringify({
                                        popUpData:
                                          this.state.proxyjson.popUpDataGrid[
                                            ind
                                          ][index],
                                        storeName:
                                          this.state.proxyjson.stores[ind],
                                        type: this.state.proxyjson.type,
                                        head: this.state.proxyjson.thead[
                                          index + 1
                                        ],
                                      })
                                  : data3
                              }
                            >
                              {this.props.name == "HandoversMonthlyBSU"
                                ? typeof data3 == "string"
                                  ? data3.includes("%")
                                    ? data3
                                    : null
                                  : data3 + "%"
                                : data3}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}

export default DataTables;
